

// Decorators / vue / vuex
import { Component, Watch, Vue, Mixins } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";

// Child component
import NavHeader from "@/components/NavHeader.vue";
import ActionLibrary from "@/components/actions/ActionLibrary.vue";
import ActionPlans from "@/components/actions/ActionPlans.vue";
import ConfigureTasks from "@/views/ConfigureTasks.vue";

// Types
import { UserPermissions, FeaturesList } from '@/store/types';

// Third Party components
import VuePerfectScrollbar from "vue-perfect-scrollbar";

// Third Party
import { get } from "lodash";

// Namespaces

const Tasks = namespace("tasks");
const Areas = namespace("areas");

@Component({
	components: {
        "nav-header": NavHeader,
        "action-library": ActionLibrary,
        "action-plans": ActionPlans,
        "vue-perfect-scrollbar": VuePerfectScrollbar,
        "configure-tasks": ConfigureTasks
	}
})
export default class ActionSetup extends Vue {
    
    @State(state => state.User.userPermissions) userPermissions: UserPermissions;

    @State featuresList: FeaturesList;

    //-- Vuex bindings --//
    @Action fetchUserGroups: () => Promise<void>;

    @Tasks.Action fetchTaskCategories: () => Promise<void>;
    @Tasks.Action fetchActionPlans: () => Promise<void>;
    @Tasks.Action fetchActionLibrary: () => Promise<void>;
    @Tasks.Action fetchTaskTypes: () => Promise<void>;    
    @Areas.Action getAreaList: () => Promise<void>;

    private isLoading: boolean = false;

	public async mounted(): Promise<void> {
        this.isLoading = true;
        await this.fetchUserGroups();
        await this.fetchTaskCategories();
        await this.fetchActionLibrary();
        await this.fetchTaskTypes();
        await this.getAreaList();
        this.isLoading = false;
    }
    
    public get permissionCheck(): boolean {
        return this.userPermissions && (this.userPermissions.canEditSettings || this.userPermissions.canViewActionPlans || this.userPermissions.canEditActionPlans);
    }

    private get actionSetupFeature(): boolean {
        return get(this.featuresList, ["ActionSetup"]);
    }
}
